import { Button, Typography } from '@mui/material'
import { ArrowLeftCircle, CheckCircle } from 'react-feather'

export const DefaultFinishStep = (props) => {
    const {handleClickReturnStep, handleClickCloseForm} = props
    return (
        <div className='text-center'>
            <Typography variant="h5" gutterBottom>
                Confirmación de procedimiento.
            </Typography>
            <p> 
                Todos los pasos se han cumplido, 
                haga click en el botón de "Finalizar procedimiento" para volver a la pantalla principal,
                o "Volver a revisar" para volver a al paso anterior
            </p>
            <div className="border-bottom border-secondary m-3"></div>
            <div className="text-center">
                <Button
                    variant="contained"
                    type="button"
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                >
                    <ArrowLeftCircle/>
                </Button>
                <Button
                    variant="contained"
                    type='button'
                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                    onClick={handleClickCloseForm}
                >
                    <CheckCircle/>
                </Button>
            </div>
        </div>
    )
}
